/**
 * Dynamically injects @font-face rules for custom fonts and resolves the
 * CSS font-family name. Works for both the public character page (where the
 * API returns the signed URL) and the live builder preview.
 */
export function useCustomFont(
  fontFamily: Ref<string> | ComputedRef<string>,
  fontUrl: Ref<string | null> | ComputedRef<string | null>
) {
  const resolvedFamily = computed(() => {
    if (fontFamily.value.startsWith('custom:') && fontUrl.value) {
      return `CustomFont-${fontFamily.value.replace('custom:', '')}`
    }
    return fontFamily.value
  })

  if (import.meta.client) {
    watch([fontFamily, fontUrl], ([family, url]) => {
      if (!family.startsWith('custom:') || !url) return
      const name = `CustomFont-${family.replace('custom:', '')}`
      if (document.getElementById(`custom-font-${name}`)) return
      const style = document.createElement('style')
      style.id = `custom-font-${name}`
      style.textContent = `@font-face { font-family: '${name}'; src: url('${url}'); font-display: swap; }`
      document.head.appendChild(style)
    }, { immediate: true })
  }

  return { resolvedFamily }
}
